import { Alert, Box, Button, Card, CardContent, CardHeader, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { apiConstants, get } from '../../common/constants'
import * as React from 'react'
import { FormProvider, RHFSelectField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import { DownloadExcelMultipleSheets } from "../../helpers/ExcelGenerator";
import { formatCurrency } from "../../helpers/UtilityHelper";
import _ from "lodash";
import { useGetAllCourierPartnersCachedQuery } from "../../redux/commonApiCalls";
import PageTitle from "../../components/PageTitle";
import Loader from "../../common/Loader";
import ProzoDataGrid from "../../common/ProzoDataGrid";

const columns = [
    {
        field: 'zoneKey',
        headerName: 'Zone',
        width: 120,
        sortable: false,
        renderCell: (col) => {
            return col.row.zoneKey || col.row.zoneName || col.row.zone || '-'
        }
    },
    {
        field: 'startWt',
        headerName: 'Start Weight (gm)',
        width: 150,
        sortable: false,
        renderCell: (col) => {
            return col.row.slab[0].startWt
        }
    },
    {
        field: "maxWt",
        headerName: "Max weight (gm)",
        width: 150,
        sortable: false,
        renderCell: (col) => {
            return col.row.slab[0].maxWt
        }


    },
    {
        field: 'price',
        headerName: 'Price',
        width: 100,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].price ? ("₹ " + col.row.slab[0].price) : "-")
        }

    },
    {
        field: 'additionalUnit',
        headerName: 'Additional Unit(gm)',
        width: 100,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].additionalUnit)
        }
    },
    {
        field: 'additionalUnitRate',
        headerName: 'Additional Unit Rate',
        width: 100,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].additionalUnitRate)
        }
    },
    {
        field: 'volumetricCoeff',
        headerName: 'Volumetric Coefficient ',
        width: 100,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].volumetricCoeff)
        }
    },
    {
        field: 'taxPercent',
        headerName: 'Tax',
        width: 100,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].taxPercent ? (col.row.slab[0].taxPercent + " %") : "-")
        }
    },
    {
        field: 'surchargePercent',
        headerName: 'Surcharge %',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].surchargePercent ? (col.row.slab[0].surchargePercent + " %") : "-")
        }
    },
    {
        field: 'docketCharge',
        headerName: 'Docket Charge',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].docketCharge)
        }
    },
    // {
    //     field: 'invoicePercentCOD',
    //     headerName: 'Invoice Percentage for COD %',
    //     width: 130,
    // sortable: false,    
    // renderCell: (col) => {
    //         return (col.row.slab[0].invoicePercentCOD ? (col.row.slab[0].invoicePercentCOD + " %") : "-")
    //     }
    // },
    {
        field: 'codOperator',
        headerName: 'COD Operator',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].codOperator)
        }
    },
    {
        field: 'minChargableAmount',
        headerName: 'Min chargable amount',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].minChargableAmount)
        }
    },
    {
        field: 'minChargableWeight',
        headerName: 'Min chargable Weight',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].minChargableWeight)
        }
    },
    {
        field: 'appointmentDelChargesPerKg',
        headerName: 'Appointment Delivery Charge Per Kg',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].appointmentDelChargesPerKg)
        }
    },
    {
        field: 'appointmentDelChargesMin',
        headerName: 'Appointment Delivery Charge Min',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].appointmentDelChargesMin)
        }
    },
    {
        field: 'oda1PerKg',
        headerName: 'ODA1 Per Kg',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].oda1PerKg)
        }
    },
    {
        field: 'oda2PerKg',
        headerName: 'ODA2 Per Kg',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].oda2PerKg)
        }
    },
    {
        field: 'oda3PerKg',
        headerName: 'ODA3 Per Kg',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].oda3PerKg)
        }
    },
    {
        field: 'odaMin',
        headerName: 'ODA Min',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].odaMin)
        }
    },
    {
        field: 'fovORPerInv',
        headerName: 'FOV (OR) INV%',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].fovORPerInv ? col.row.slab[0].fovORPerInv + " %" : '-')
        }
    },
    {
        field: 'fovORMin',
        headerName: 'FOV (OR) Min',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].fovORMin)
        }
    },
    {
        field: 'boxHandlingChargableWt',
        headerName: 'Box Handling Chargable Weight',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].boxHandlingChargableWt)
        }
    },
    {
        field: 'boxHandlingMin',
        headerName: 'Box Handling Min Charge',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].boxHandlingMin)
        }
    },
    {
        field: 'maxDamLossLiability',
        headerName: 'Max Damage/Lost liability',
        width: 110,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].maxDamLossLiability)
        }
    },
    {
        field: 'minTat',
        headerName: 'B2B Min TAT',
        sortable: false,
        width: 100,

    },
    {
        field: 'maxTat',
        headerName: 'B2B Max TAT',
        sortable: false,
        width: 100,

    },
    {
        field: 'rtoPercentOfForward',
        headerName: 'RTO (Forward %)',
        width: 100,
        sortable: false,
        renderCell: (col) => {
            return (col.row.slab[0].rtoPercentOfForward ? (col.row.slab[0].rtoPercentOfForward + " %") : "-")
        }
    },
]



function B2bCourierRateCard() {
    const [price, setPrice] = useState([]);
    const [response, setResponse] = useState(null);
    const [slab, setSlab] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(20);

    const method = useForm({
        // resolver: yupResolver(
        //     Yup.object().shape({
        //         ZoneName: Yup.string().required("Please select zone"),
        //         courier: Yup.string().required("Please select courier"),
        //     })
        // ),
        defaultValues: {
            ZoneName: '',
            courier: ''
        }
    });
    const {
        watch,
        reset,
    } = method;

    const courierName = watch("courier")
    const selectedZone = watch("ZoneName");

    useEffect(() => {
        if (courierName) {
            setLoading(true)
            get(`${apiConstants.B2B_RATE_CARD}/?id=${courierName}&type=courier`).then((res) => {
                setResponse(res?.data)
            }).catch((err) => console.log(err)).finally(() => setLoading(false))
        }
    }, [courierName])


    useEffect(() => {
        if (courierName) {
            fetchPriceData(courierName, selectedZone);
        }
    }, [courierName, selectedZone, response]);

    useEffect(() => {
        if (courierName && !selectedZone) {
            fetchPriceData(courierName, null);
        }
    }, [selectedZone, courierName]);

    async function fetchPriceData(courier, zone) {
        if (courier) {
            if (zone) {
                const selectedRate = response?.sla[zone]
                if (selectedRate) {
                    const priceData = selectedRate;
                    setPrice([priceData]);
                } else {
                    setPrice([]);
                }
            } else {
                const selectedRate = response?.sla;
                if (selectedRate) {
                    const allZonesData = Object.entries(selectedRate).map(([zoneKey, zoneData]) => ({
                        ...zoneData,
                        zoneKey: zoneKey,
                        id: `zone_${zoneKey}_${Date.now()}`
                    }));
                    setPrice(allZonesData);
                } else {
                    setPrice([]);
                }
            }
        }
    }


    useEffect(() => {
        if (response?.active === true) {
            const dropdownOptions = Object.keys(response?.sla).map(val => ({
                label: val,
                value: val
            }))
            setSlab(dropdownOptions);
        } else {
            setSlab(null);
        }
    }, [response])

    const zoneOptionsWithAll = slab ? [
        ...(slab || [])
    ] : [];



    const normalizeDataForExport = (data) => {
        if (!data || data.length === 0) return [];
        return data.map(item => {
            const slabData = item.slab ? item.slab[0] : item;
            return {
                ...item,
                normalizedSlab: slabData
            };
        });
    };


    const sheets = [
        {
            name: "Courier Rate Card",
            data: normalizeDataForExport(price.length > 0 ? price : []),
            columns: [
                {
                    label: 'Courier',
                    value: (col) => courierName || '-'
                },
                {
                    label: 'Zone',
                    value: (col) => col.zoneKey || col.zone || col.zoneName || '-'
                },
                {
                    label: 'Start Weight(gm)',
                    value: (col) => col.normalizedSlab.startWt,
                },
                {
                    label: 'Max Weight(gm)',
                    value: (col) => col.normalizedSlab.maxWt
                },
                {
                    label: 'Price',
                    value: (col) => formatCurrency(col.normalizedSlab.price)
                },
                {
                    label: 'Additional Unit(gm)',
                    value: (col) => (col.normalizedSlab.additionalUnit)
                },
                {
                    label: 'Additional Unit Rate',
                    value: (col) => formatCurrency(col.normalizedSlab.additionalUnitRate)
                },
                {
                    label: 'Volumetric Coefficient',
                    value: (col) => col.normalizedSlab.volumetricCoeff
                },
                {
                    label: 'Tax',
                    value: (col) => col.normalizedSlab.taxPercent ? (col.normalizedSlab.taxPercent + " %") : "-"
                },
                {
                    label: 'Surcharge %',
                    value: (col) => col.normalizedSlab.surchargePercent ? (col.normalizedSlab.surchargePercent + " %") : "-"
                },
                {
                    label: 'Docket Charge',
                    value: (col) => formatCurrency(col.normalizedSlab.docketCharge)
                },
                {
                    label: 'COD Operator',
                    value: (col) => col.normalizedSlab.codOperator
                },
                {
                    label: 'Min chargable amount',
                    value: (col) => formatCurrency(col.normalizedSlab.minChargableAmount)
                },
                {
                    label: 'Min chargable Weight',
                    value: (col) => col.normalizedSlab.minChargableWeight
                },
                {
                    label: 'Appointment Delivery Charge Per Kg',
                    value: (col) => formatCurrency(col.normalizedSlab.appointmentDelChargesPerKg)
                },
                {
                    label: 'Appointment Delivery Charge Min',
                    value: (col) => formatCurrency(col.normalizedSlab.appointmentDelChargesMin)
                },
                {
                    label: 'ODA1 Per Kg',
                    value: (col) => (col.normalizedSlab.oda1PerKg
                    )
                },
                {
                    label: 'ODA2 Per Kg',
                    value: (col) => (col.normalizedSlab.oda2PerKg)
                },
                {
                    label: 'ODA3 Per Kg',
                    value: (col) => col.normalizedSlab.oda3PerKg
                },
                {
                    label: 'ODA Min',
                    value: (col) => formatCurrency(col.normalizedSlab.odaMin)
                },
                {
                    label: 'FOV (OR) INV%',
                    value: (col) => col.normalizedSlab.fovORPerInv ? (col.normalizedSlab.fovORPerInv + " %") : "-"
                },
                {
                    label: 'FOV (OR) Min',
                    value: (col) => col.normalizedSlab.fovORMin
                },
                {
                    label: 'Box Handling Chargable Weight',
                    value: (col) => formatCurrency(col.normalizedSlab.boxHandlingChargableWt)
                },
                {
                    label: 'Box Handling Min Charge',
                    value: (col) => col.normalizedSlab.boxHandlingMin
                },
                {
                    label: 'Max Damage/Lost liability',
                    value: (col) => col.normalizedSlab.maxDamLossLiability
                },
                {
                    label: 'B2B MIN TAT',
                    value: (col) => col.normalizedSlab.b2bTaT?.minTat
                },
                {
                    label: 'B2B MAX TAT',
                    value: (col) => col.normalizedSlab.b2bTaT?.maxTat
                },
                {
                    label: 'RTO (Forward %)',
                    value: (col) => col.normalizedSlab.rtoPercentOfForward ? (col.normalizedSlab.rtoPercentOfForward + " %") : "-"
                },
            ]
        }
    ]

    const andfilter = [{ "field": "is_deleted", "operator": "eq", "value": '0' }];
    const filter = {
        "andfilter": andfilter,
        "offset": 0,
        "limit": 1000,
        "skipCount": true,
        "includes": "id,name,cpAccountCode,prozoId,supportedShipmentType,isBlended,type"
    }
    const { data } = useGetAllCourierPartnersCachedQuery(filter);
    const filteredData = data?.filter(val => val.supported_shipment === "B2B");


    return (
        <>
            {loading && <Loader />}
            <PageTitle> Courier Rate Card (B2B)</PageTitle>
            <Card sx={{ mb: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                <CardHeader title='Courier Rate Card (B2B)'
                    subheader="View pricing details for business shipments, including zone-based rates and courier partner settings."
                    action={
                        <DownloadExcelMultipleSheets
                            sheets={sheets}
                            filename="B2B Courier Rate Card"
                            disabled={!courierName}
                        />
                    }
                />
                <CardContent>
                    <FormProvider methods={method}>
                        <Grid container spacing={2} alignItems="center" paddingBottom={1}>
                            <Grid item xs={12} md={4} sx={{ overflow: 'hidden' }}>
                                <RHFSelectField
                                    name="courier"
                                    label="Select Courier"
                                    options={_.orderBy(filteredData, 'name').map(val => ({
                                        value: val.prozoId,
                                        label: val.prozoId,
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <RHFSelectField name="ZoneName"
                                    width="100%"
                                    label="Zone Name"
                                    disabled={!slab}
                                    options={zoneOptionsWithAll}
                                />
                            </Grid>
                            {/* } */}
                            <Grid item xs={12} md={4}>
                                <Button onClick={() => {
                                    setPrice([])
                                    setSlab(null)
                                    setResponse(null)
                                    reset()
                                }}
                                    variant="contained"
                                    size="small"
                                    sx={{ bgcolor: '#ef4444', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#dc2626' } }}
                                >Reset</Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                    {!courierName && (
                        <Alert sx={{ mt: 2 }} severity="info">Please select a courier to view rate card details and enable the download functionality. The download button will be available once you choose a courier partner.</Alert>
                    )}
                    {!response && courierName && !loading && (
                        <Alert sx={{ mt: 2 }} severity="error">No active rate card found for the selected courier. Please try another courier partner.</Alert>
                    )}
                </CardContent>
            </Card >
            {price?.length > 0 &&
                <ProzoDataGrid
                    columns={columns}
                    getRowId={(row) => row.id}
                    rows={price ? price : []}
                    autoHeight={true}
                    rowCount={price?.length || Number.MAX_VALUE}
                    pagination={true}
                    paginationMode={'client'}
                    page={page}
                    getRowHeight={() => 25}
                    setPage={setPage}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                />
            }
        </>
    );
}


export default B2bCourierRateCard;